import { useState, useEffect } from 'react';

export const useSounds = () => {
  const [sounds, setSounds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSounds = async () => {
      try {
        setLoading(true);
        const response = await fetch('/sounds.json');
        
        if (!response.ok) {
          throw new Error(`Erreur HTTP: ${response.status}`);
        }
        
        const data = await response.json();
        const soundsWithId = data.map((sound, index) => ({ ...sound, id: index }));
        setSounds(soundsWithId);
        setError(null);
      } catch (err) {
        console.error('Erreur lors du chargement des sons:', err);
        setError('Impossible de charger les sons. Veuillez réessayer plus tard.');
        setSounds([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSounds();
  }, []);

  return { sounds, loading, error };
};
